import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { PresentationProvider } from '../../context/PresentationProvider';
import CollectionReviews from './CollectionReviews.component.js';

export const CollectionReviewsWithPresentation = (props) => {
  const { channel } = useContext(ExperienceContext);
  const useCondensedLayout = props?.forceCondensedLayout || props?.channel === 'mobile' || channel === 'mobile';
  const componentProps = {
    ...props,
    channel: useCondensedLayout ? 'mobile' : 'desktop'
  };

  return (
    <PresentationProvider useCondensedLayout={useCondensedLayout}>
      <CollectionReviews { ...componentProps } />
    </PresentationProvider>
  )
}
